import {Modal} from "react-bootstrap";
import {RxCross1} from "react-icons/rx";
const ScriptPreview = ({ scriptdata, show,hidecall }) => {

  return (
  
      <Modal show={show} onHide={() => hidecall()} fullscreen={true}>
      
          <div style={{display:"flex", justifyContent:"flex-end" , borderBottom:"2px solid #ddd" , padding:"15px", paddingRight:"30px"}}>
<RxCross1 style={{color:"gray" , fontSize:"20px" , fontWeight:"700",cursor:"pointer"}} onClick={()=>{
hidecall()
}}/>
          </div>
 
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: scriptdata }} />
        </Modal.Body>
      </Modal>

  );
};

export default ScriptPreview;
